import { createSelector } from '@reduxjs/toolkit';
import { selfMsgSelector } from './self';

const imagesSelector = createSelector(selfMsgSelector, (messages) => messages.images);

export default imagesSelector;
